<template>
    <section class="login">
        <div class="login__content">
            <router-link :to="{ name : 'home' }" class="logo" :title="$t('nav.logo')">
                <img src="/assets/img/as-logo-color.svg" :alt="$t('nav.logo')" />
            </router-link>

            <h1>{{ $t('nav.logo') }}</h1>

            <form action="" method="POST" novalidation @submit="onSubmitLoginForm">
                <template v-if="loginError !== null">
                    <div class="form-message form-message--error" >
                        {{ loginError }}
                    </div>
                </template>
                <div class="form-group" :class="{ 'form-group--error' : $v.loginObject.username.$error }">
                    <label for="form-field-username">{{ $t('form.email') }}</label>
                    <input type="text" id="form-field-username" name="username" v-model="$v.loginObject.username.$model" />
                </div>
                <div class="form-group" :class="{ 'form-group--error' : $v.loginObject.password.$error }">
                    <label for="form-field-password">{{ $t('form.password') }}</label>
                    <input type="password" id="form-field-password" name="password" v-model="$v.loginObject.password.$model" />
                </div>
                <!-- <div class="form-group form-group--check">
                    <label><input type="checkbox" name="checkbox1" value="1" /> <i></i> An mich erinnern</label>
                </div> -->
                <div class="form-group">
                    <button role="button" type="submit" class="button primary" :title="$t('form.login.submit')" :disabled="loginStatus">
                        {{ $t('form.login.submit') }}
                    </button>
                </div>
            </form>
            <button role="button" class="button--toggle-password" :title="$t('login.forgot_password')" @click="onTogglePasswordForm">
                {{ $t('login.forgot_password') }}
            </button>

            <form action="" method="POST" novalidation @submit="onSubmitPasswordForm" v-show="showPassword">
                <template v-if="passwordError !== null">
                    <div class="form-message form-message--error" >
                        {{ passwordError }}
                    </div>
                </template>
                <template v-if="passwordSuccess !== null">
                    <div class="form-message form-message--success" >
                        {{ passwordSuccess }}
                    </div>
                </template>
                <div class="form-group" :class="{ 'form-group--error' : $v.passwordObject.email.$error }">
                    <label for="form-field-email">{{ $t('form.email') }}</label>
                    <input type="text" id="form-field-email" name="email" v-model="$v.passwordObject.email.$model" />
                </div>
                <div class="form-group">
                    <button role="button" type="submit" class="button primary" :title="$t('form.forgot_password.submit')" :disabled="passwordStatus">
                        {{ $t('form.forgot_password.submit') }}
                    </button>
                </div>
            </form>
            <footer class="u-extra-medium-margin--top">
                <a href="https://www.as-asphaltbau.de/impressum" class="button--toggle-password">Impressum</a> |  <a href="https://www.as-asphaltbau.de/datenschutzerklaerung" class="button--toggle-password">Datenschutzerklärung</a>
            </footer>
        </div>
        <div class="login__image" style="background-image: url('/assets/img/login-bkg-26082019.jpg');"></div>
    </section>
</template>

<script>
    import { required, email } from 'vuelidate/lib/validators';

    export default {
        data() {
            return {
                loginObject     : {
                    username        : '',
                    password        : ''
                },
                loginError      : null,
                loginStatus     : false,
                showPassword    : false,
                passwordObject  : {
                    email           : ''
                },
                passwordError   : null,
                passwordSuccess : null,
                passwordStatus  : false
            }
        },
        validations : function () {
            return {
                loginObject : {
                    username    : {
                        required
                    },
                    password    : {
                        required
                    }
                },
                passwordObject : {
                    email       : {
                        required,
                        email
                    }
                }
            };
        },
        methods : {
            onSubmitLoginForm : function (event) {
                event.preventDefault();

                this.loginStatus    = true;
                this.loginError     = null;

                this.$v.loginObject.$touch();

                if (this.$v.loginObject.$invalid) {
                    this.loginStatus    = false;
                    this.loginError     = this.$t('form.login.error_form');
                } else {
                    let promise = this.$api.userLogin(this.loginObject);

                    promise.then((response => {
                        this.$api.userGetAccount()
                            .then((response => {
                                this.$router.push({ name : 'home' });
                            }).bind(this)).catch((error => {
                                return Promise.reject(error);
                        }).bind(this));
                    }).bind(this)).catch((error => {
                        this.loginStatus    = false;
                        this.loginError     = error.response.data.message;
                    }).bind(this));
                }
            },
            onTogglePasswordForm : function () {
                this.showPassword = !this.showPassword;
            },
            onSubmitPasswordForm : function (event) {
                event.preventDefault();

                this.passwordStatus     = true;
                this.passwordError      = null;
                this.passwordSuccess    = null;

                this.$v.passwordObject.$touch();

                if (this.$v.passwordObject.$invalid) {
                    this.passwordStatus     = false;
                    this.passwordError      = this.$t('form.forgot_password.error_form');
                    this.passwordSuccess    = null;
                } else {
                    let promise = this.$api.clearParams()
                        .post('password/forgot', this.passwordObject);

                    promise.then((response => {
                        this.passwordStatus     = false;
                        this.passwordError      = null;
                        this.passwordSuccess    = this.$t('form.forgot_password.success');
                    }).bind(this)).catch((error => {
                        this.passwordStatus     = false;
                        this.passwordError      = error.response.data.message;
                        this.passwordSuccess    = null;
                    }).bind(this));
                }
            }
        }
    }
</script>